export default el => {
	console.log(el);
	el.addEventListener("submit", (e) => {
		e.preventDefault();

		var url = "/recherche";
		const keywords = el.querySelector(".search__box__input");
		const filters = el.querySelectorAll(".filter");

		if (keywords.value.length > 0) {
			url += '/' + keywords.value;
		}

		var j = 0;

		var datas = {};

		var j = 0;
		filters.forEach(filter => {
			const inputs = filter.querySelectorAll("input:checked");

			if (inputs) {
				var i = 0;
				inputs.forEach(input => {
					if (i == 0) {
						var name = "";
						switch (input.name) {
							case "categories[]":
								name = "categories";
								break;

							case "periods[]":
								name = "periodes";
								break;

							default:
								break;
						}

						datas[j] = {
							'name': name,
							'values': [input.value]
						}
					}

					else {
						datas[j]['values'].push(input.value);
					}

					i++;
				})

				j++;
			}
		})

		if (Object.keys(datas).length > 0) {
			url += '/filtres';

			for (const [key, value] of Object.entries(datas)) {
				url += `/${value.name}/${value.values.join(',')}`;
			}
		}

		window.location = encodeURI(url);

	})
};